import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import Moment from 'moment';
import classNames from 'classnames';
import GenericModal from '../../GenericModal'
import EmployeeService from '../../../services/Employee.service'
import Select, { components } from 'react-select';
import ReactSelect from '../../ReactSelect';
import PlaySolid from '../../../images/play-solid.svg'
import CheckBoxOff from '../../../images/checkbox-off.svg'
import CheckBoxOn from '../../../images/checkbox-on.svg'
import { addFlashMessageOfType } from 'redux-flash-messages'
import { actions as employeeActions } from '../../../actions/employee'
import { actions as maintenanceActions } from '../../../actions/maintenance'
import { history } from '../../../store'

const Content = styled.div`

  padding: 16px 20px 17px 20px;

  label {
    font-family: Lato-Regular;
    font-size: 12px;
    font-weight: normal;
    color: #666666;
    line-height: 16px;
    margin: 0px;
    padding: 0px;
    margin-bottom: 7px;
    display: block;
  }

  > div.new-tax-rate-area {
    margin-top: 17px;
    display: block;
    height: 70px;

    > div:nth-child(1), > div:nth-child(3) {
      width: 40%;
    }

    > div:nth-child(2) {
      width: 20%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 44px;
      margin-top: 23px;
    }

    > div {
      float: left;

      > span {
        font-family: Lato-Regular;
        font-size: 14px;
        color: #666666;
        line-height: 22px;
        padding: 11px 16px;
        background-color: #EDEDED;
        //width: 100%;
        display: block;
      }

      > div.Select {
      // display: block;
        .Select-control {
          height: 42px !important;
        }
      }
    }
  }

  .additional-filters {
    > div.Select {
      margin-top: 17px;
    }
  }

  .custom-option-container {
    padding: 12px 15px;
    border-bottom: 1px #2B2B2B;
  }

  .custom-option-container-selected {
    padding: 12px 15px;
    background-color: black;
  }

  .vest-event-option {
    height: 40px;

    > div {
      height: 100%;
    }

    div:nth-child(1) {
      float: left;

      span {
        display: block;
      }

      span.vest-date {
        font-family: Lato-Regular;
        font-size: 14px;
        color: #2B2B2B;
        line-height: 22px;
      }

      span.vest-name {
        font-family: Lato-Regular;
        font-size: 12px;
        color: #666666;
        line-height: 16px;
      }
    }

    div:nth-child(2) {
      float: right;
      display: flex;
      align-items: center;

      span.vest-current-rate {
        font-family: Lato-Regular;
        font-size: 12px;
        color: #666666;
        line-height: 16px;

        // Desktop version.
        @media (min-width: 768px) {
          margin-right: 16px;
        }

        // Mobile version.
        @media (max-width: 768px) {
          margin-right: 5px;
        }
      }

      span.fake-checkbox {
        width: 23px;
        height: 23px;
        background: url(${CheckBoxOff});
        background-size: 23px 23px;
      }

      span.fake-checkbox.checked {
        background: url(${CheckBoxOn});
        background-size: 23px 23px;
      }
    }
  }

`

const Footer = styled.div`
  > button {
    height: 43px;
    width: 100%;
  }
`

const ChevronImage = styled.img`
  width: 14px;
  height: 8px;
  margin-right: 8px;
`

const CustomOption = (props) => {
  const { innerProps, innerRef, isSelected } = props;
  // const option = props.data;
  // const {vest, award} = option;

  // let currentRateLabel = this.props.t("ChangeTaxRateDialog.VestEventCurrentRate");
  // var currentRate = (vest.fed_override_tax || award.fed_override_tax);
  // currentRate = new Intl.NumberFormat(this.props.locale, { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(currentRate);


  // let vest_date = Moment(vest.vest_date).format('ll');


  return (
    <components.Option {...props}>
      <div style={{width: '50%', display: 'inline-block'}}>
        <div>
          TOP INFO
        </div>
        <div>
          BOTTOM INFO
        </div>
      </div>
      <div style={{width: '50%', display: 'inline-block'}}>
        {props.data.label}
      </div>
    </components.Option>
  );
}


export class ChangeTaxRateDialog extends Component {

  constructor(props) {
    super(props);
    this.state = this.defaultState(props)
  }


  defaultState = (props) => {
    let defaultAdditionFiltersVisible
    let defaultFederalTaxRateType
    let defaultSecondFilter

    if(props.viewType === 'award') {
      if (props.awardIdSelected === null) { // Default selection.
        defaultAdditionFiltersVisible = false
        defaultFederalTaxRateType = "AllWards"
        defaultSecondFilter = Object.keys(props.groups)[0]
      } else { // Award selection.
        defaultAdditionFiltersVisible = true
        defaultFederalTaxRateType = "ByAwardVest"
        defaultSecondFilter = props.awardIdSelected
      }
    } else if(props.viewType === 'calendar-year') {
      defaultAdditionFiltersVisible = true
      defaultFederalTaxRateType = "ByYear"
      defaultSecondFilter = props.calendarYear === null ? Object.keys(props.groups)[0] : parseInt(props.calendarYear)
    } else {
      defaultAdditionFiltersVisible = false
      defaultFederalTaxRateType = "AllWards"
      defaultSecondFilter = Object.keys(props.groups)[0]
    }

    return {
      additionFiltersVisible: defaultAdditionFiltersVisible,
      federalTaxRateTypeSelected: defaultFederalTaxRateType,
      secondFilterSelected: defaultSecondFilter,
      vestEventSelected: "value1",
      newTaxRateSelected: null,
      vestSelectionMessage: props.t("ChangeTaxRateDialog.AllVestEvents"),
      vestEvents: new Map(),
      toggleMenuOpen: false
    }
  }

  taxRateAppliedHandler = (callback) => {
    let apply_future = false
    let awards = []
    let vests = []
    let tax_rate = this.state.newTaxRateSelected

    if (this.state.federalTaxRateTypeSelected === "AllWards") {
      apply_future = true
      vests = this.props.unvested_awards.reduce((award_vests, award) => {
          award_vests = award_vests.concat(award.vests.filter((vest) => !vest.vested ).map((vest) => {
            return vest.id
          }))
        return award_vests
      }, [])
    } else if (this.state.federalTaxRateTypeSelected === "CurrentAwards") {
      vests = this.props.unvested_awards.reduce((award_vests, award) => {
        award_vests = award_vests.concat(award.vests.filter((vest) => !vest.vested ).map((vest) => {
          return vest.id
        }))
        return award_vests
      }, [])
    } else if (this.state.federalTaxRateTypeSelected === "ByYear") {
      if (this.state.vestEvents.size === 0) {
        let vestsByYear = this.props.groups[this.state.secondFilterSelected]
        vests = vestsByYear.remaining.map((vest) => {
          return vest.id
        })
      } else {
        vests = [ ...this.state.vestEvents.keys()]
      }
    } else if (this.state.federalTaxRateTypeSelected === "ByAwardVest") {
      if (this.state.vestEvents.size === 0) {
        let award = EmployeeService.loadAward(this.props.unvested_awards, this.state.secondFilterSelected)
        if (award && award.vests) {
          vests = award.vests.filter((vest) => !vest.vested )
          .map((vest) => {
            return vest.id
          })
        }
      } else {
        vests = [ ...this.state.vestEvents.keys()]
      }
    }

    // Do nothing if it doesn't has awards or vests.
    if ((awards.length === 0 && vests.length === 0) || this.state.federalTaxRateTypeSelected === null) {
      this.props.onCloseDialog()
      addFlashMessageOfType("SUCCESS", 5000, this.props.t('ChangeTaxRateDialog.USFederalTaxRateApplied'), null, null);
      return
    }
    this.props.actions.maintenance.checkMaintenaceStatus().then(isLive => {

      if(isLive) {
        this.props.actions.employee.applyTaxRate(awards, vests, tax_rate, apply_future ).then( _ => {
          this.props.onCloseDialog()
          addFlashMessageOfType("SUCCESS", 5000, this.props.t('ChangeTaxRateDialog.USFederalTaxRateApplied'), null, null);
        }).catch( _ => {
          console.log("There was an error applying taxes")
          this.props.onCloseDialog()
          addFlashMessageOfType("ERROR", 5000, this.props.t('ChangeTaxRateDialog.FailedToApplyFederalTax'), null, null);
        })
      } else {
        history.push("/maintenance", {})
      }
    })

  }

  getFederalTaxRateTypeOptions = (t) => {
    var options = []
    var codes = ["AllWards", "CurrentAwards", "ByYear", "ByAwardVest"]
    codes.map((el, index) => {
      return options.push({value: el, label: t(`FederalTaxRateType.${el}`)})
    })

    return options
  }

  getTaxRatesOptions = (t) => {
    let options = this.props.configuration.tax_rates.map( taxRate => (
      {value: taxRate, label: `${new Intl.NumberFormat(this.props.locale, {style: 'percent',minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(taxRate)}`})
    )

    return options
  }

  getSecondFilterOptions = () => {
    var options = []

    if (this.state.federalTaxRateTypeSelected === "ByYear") {
      Object.keys(this.props.groups).forEach((key)=>{
        if(this.props.groups[key].remaining.length > 0) {
          options.push({value: key, label: key})
        }
      })

    } else if (this.state.federalTaxRateTypeSelected === "ByAwardVest") {
      this.props.unvested_awards.map((award,index) => {
        return options.push({value: award.id, label: `${award.amazon_award_name} | ${award.amazon_award_id}`})
      })
    }

    return options
  }

  getVestEventOptions = (t) => {
    var options = []
    if(this.state.federalTaxRateTypeSelected === "ByYear") {
      const vests = this.props.groups[this.state.secondFilterSelected]

      vests && vests.remaining.map((vest, index) => {
        const award = EmployeeService.loadAward(this.props.awards, vest.award_id)
        return options.push({value: vest.id.toString(), label: `${award.amazon_award_name} | ${award.amazon_award_id}`, award: award, vest: vest})
      })
    } else if(this.state.federalTaxRateTypeSelected === "ByAwardVest") {
      const award = EmployeeService.loadAward(this.props.unvested_awards, this.state.secondFilterSelected)
      if (award) {
        award.vests && award.vests.filter((vest) => !vest.vested )
        .map((vest, index) => {
          return options.push({value: vest.id.toString(), label: `${award.amazon_award_name} | ${award.amazon_award_id}`, award: award, vest: vest})
        })
      }
    }

    return options
  }

  updateVestEventSelection = (vestEvents) => {
    let vestSelectionMessage = (vestEvents.size > 0) ? this.props.t('ChangeTaxRateDialog.VestEvents', { vestEvents: vestEvents.size }) : this.props.t("ChangeTaxRateDialog.AllVestEvents")
    this.setState({
      vestEvents: vestEvents,
      vestSelectionMessage: vestSelectionMessage
    });
  }

  resetVestEventSelection = () => {
    this.updateVestEventSelection(new Map())
  }

  renderVestEventOption = (option) => {
    const {vest, award} = option

    let currentRateLabel = this.props.t("ChangeTaxRateDialog.VestEventCurrentRate")
    var currentRate = (vest.fed_override_tax || award.fed_override_tax)
    currentRate = new Intl.NumberFormat(this.props.locale, {style: 'percent',minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(currentRate)

    let vestEventSelected = this.state.vestEvents.has(parseInt(option.value))
    let vest_date = Moment(vest.vest_date).format('ll')
    let fakeCheckBoxClassName = classNames({
      'fake-checkbox': true,
      'checked': vestEventSelected
    });

    return (
      <div className="vest-event-option" value={option.value}>
        <div>
          <span className="vest-date">{vest_date}</span>
          <span className="vest-name">{option.label}</span>
        </div>
        <div>
          <span className="vest-current-rate">{currentRateLabel}: {currentRate}</span>
          <span className={fakeCheckBoxClassName}/>
        </div>
      </div>
    )
  }

  onFederalTaxTypeChange = (selectedOption) => {
    let additionFiltersVisible = (selectedOption.value === "ByYear" || selectedOption.value === "ByAwardVest")
    this.setState({
      additionFiltersVisible: additionFiltersVisible,
      federalTaxRateTypeSelected: selectedOption.value,
      secondFilterSelected: selectedOption.value === "ByYear" ? Object.keys(this.props.groups)[0] : this.props.unvested_awards[0].id
    });
    this.resetVestEventSelection()
  }

  onSecondFilterChange = (selectedOption) => {
    this.setState({
      secondFilterSelected: selectedOption.value
    });
    this.resetVestEventSelection()
  }

  onVestEventChange = (selectedOption) => {
    let vestEvents = this.state.vestEvents
    let vestId = parseInt(selectedOption.value)

    if (vestEvents.has(vestId)) {
      vestEvents.delete(vestId)
    } else {
      vestEvents.set(vestId, selectedOption.vest)
    }

    this.updateVestEventSelection(vestEvents)
  }

  onNewTaxRateChange = (selectedOption) => {
    this.setState({
      newTaxRateSelected: selectedOption.value
    });
  }

  formatPercentage = value => (
    new Intl.NumberFormat(this.props.locale, { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(value)
  )

  getTaxRatesRange = () => {
    const { federalTaxRateTypeSelected, secondFilterSelected } = this.state
    const { default_tax_rate } = this.props.configuration
    let list = []

    if (federalTaxRateTypeSelected === 'CurrentAwards') {
      this.props.unvested_awards.forEach(award => {
        award.vests.forEach(vest =>{
            list = list.concat(vest)
        })
      })
    } else if (federalTaxRateTypeSelected === 'ByYear') {
      if (this.state.vestEvents.size === 0) {
        if(Object.keys(this.props.groups).length <= 0) {
          return default_tax_rate
        } else {
          const vestsByYear = this.props.groups[secondFilterSelected]
          list = vestsByYear.remaining
        }

      } else {
        list = [...this.state.vestEvents.values()]
      }
    } else if (federalTaxRateTypeSelected === 'ByAwardVest') {
      if (this.state.vestEvents.size === 0) {
        const award = EmployeeService.loadAward(this.props.unvested_awards, secondFilterSelected)
        if (award && award.vests) {
          list = award.vests.filter(vest => !vest.vested)
        }
      } else {
        list = [...this.state.vestEvents.values()]
      }
    } else { // AllWards
      this.props.awards.forEach(award => {
        award.vests.forEach(vest =>{
          list = list.concat(vest)
        })
      })
    }

    let taxRatesRange = EmployeeService.getTaxRatesRange(list, default_tax_rate)
    return taxRatesRange.map(tr => this.formatPercentage(tr)).join(' - ')
  }

  onSelectVestEvent = (selectedOption) => {
    const selectedVestEvent = new Map();
    selectedOption.map(vestInfo => {
      selectedVestEvent.set(vestInfo.vest.id, vestInfo.vest);
    })
    this.setState({
      vestEvents: selectedVestEvent
    })
  }

  render() {
    if (!this.props.visible) {
      return null;
    }
    const { t, viewOnly } = this.props
    const taxRatesRange = this.getTaxRatesRange()


    const CustomOption = {
      Option: ({ ...props }) => (
        <components.Option {...props}>
          {this.renderVestEventOption(props.data)}
        </components.Option>
      )
    }

    return (
      <GenericModal
        title={t('ChangeTaxRateDialog.Title')}
        visible={this.props.visible}
        onCloseDialog={this.props.onCloseDialog}
        width={380}
        className="tax-elections"
      >
        <Content>
          <label htmlFor="federal-tax-types">{t('ChangeTaxRateDialog.ChangeUSFederalTaxRate')}</label>
          <ReactSelect
            name="federal-tax-types"
            options={this.getFederalTaxRateTypeOptions(t)}
            onChange={this.onFederalTaxTypeChange}
            value={this.getFederalTaxRateTypeOptions(t).find(opt => opt.value == this.state.federalTaxRateTypeSelected)}
            isClearable={false}
            isSearchable={false}
          />
          {this.state.additionFiltersVisible &&
            <div className="additional-filters">
              <ReactSelect
                name="second-filter"
                options={this.getSecondFilterOptions()}
                onChange={this.onSecondFilterChange}
                value={this.getSecondFilterOptions().find(opt => opt.value == this.state.secondFilterSelected)}
                isClearable={false}
                isSearchable={false}
              />
              <ReactSelect
                name="vest-event"
                options={this.getVestEventOptions()}
                onChange={this.onSelectVestEvent}
                placeholder={this.state.vestSelectionMessage}
                components={CustomOption}
                closeMenuOnSelect={false}
                isClearable={false}
                isSearchable={false}
                isMulti={true}
              />
            </div>
          }

          <div className="new-tax-rate-area">
            <div>
              <label>{t('ChangeTaxRateDialog.CurrentTaxRate')}</label>
              <span>{taxRatesRange}</span>
            </div>
            <div>
              <img alt="" src={PlaySolid} />
            </div>
            <div>
              <label htmlFor="new-tax-rate">{t('ChangeTaxRateDialog.NewTaxRate')}</label>
              <ReactSelect
                name="new-tax-rate"
                options={this.getTaxRatesOptions(t)}
                onChange={this.onNewTaxRateChange}
                value={this.getTaxRatesOptions(t).find(opt => opt.value == this.state.newTaxRateSelected)}
                isClearable={false}
                isSearchable={false}
              />
            </div>
          </div>
        </Content>
        <Footer>
          <button className="primary-button change-tax-payment" disabled={viewOnly || !this.state.newTaxRateSelected} onClick={this.taxRateAppliedHandler}>{t('ChangeTaxRateDialog.ApplyTaxRate')}</button>
        </Footer>
      </GenericModal>
    )
  }
}

const mapState = state => ({
  configuration: state.configuration,
  awards: EmployeeService.getAwardsForTaxElection(state.employee.awards),
  groups: EmployeeService.getVestsByYear(EmployeeService.getAwardsForTaxElection(state.employee.awards)),
  unvested_awards: EmployeeService.getAwardsForTaxElection(state.employee.awards).filter((el) => !el.fully_vested),
  locale: state.employee.language
})


const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch),
    maintenance: bindActionCreators(maintenanceActions, dispatch),
  }
})

export default connect(mapState,mapDispatchToProps)(withTranslation('translations')(ChangeTaxRateDialog))

